//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isChat: Boolean
  },
  data(){
    return {
      // status: 'scanning', // scanning, scanned, confirmed, expired
      qrCodeInstance: null,
      refreshTimer: null,
      iframeObserver: null
    }
  },
  computed: {
    showChat:{
      get(){
        return this.isChat
      },
      set(val){
        this.$emit('update:isChat', val);
      }
    }
  },
  mounted() {
    // 确保只在客户端执行
    if (process.client || typeof window !== 'undefined') {
      // 动态加载微信登录JS SDK
      this.loadWxLoginScript().then(() => {
        this.getCode();
      });
    }
  },
  methods: {
    isBrowser() {
      return typeof window !== 'undefined' && typeof document !== 'undefined';
    },
    // 动态加载微信登录JS
    loadWxLoginScript() {
      // 确保在浏览器环境中执行
      if (!this.isBrowser()) {
        return Promise.reject(new Error('Not in browser environment'));
      }
      return new Promise((resolve, reject) => {
        // 检查是否已经加载过
        if (window.WxLogin) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    getCode(){
      if (!this.isBrowser()) return;
      // 清除之前的定时器
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }

      // 生成随机state
      const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      // 清空二维码容器
      this.$refs.qrCode.innerHTML = '';
      const containerId = 'wechat_qrlogin_' + Date.now();
      this.$refs.qrCode.id = containerId;
      // 使用微信官方SDK生成二维码
      this.wxLoginObj = new window.WxLogin({
        self_redirect: false,
        id: containerId, // 容器ID或元素
        appid: "wx29ceb55be10183a6",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent("https://biaoju.cn/wxLogin"),
        state: state,
        style: "black",
        stylelite: 1,
        // href: "https://biaoju.cn/css/wechat-qrcode.css"
      });

      // 监听登录成功
      // 监听iframe内容变化
      this.$nextTick(() => {
        this.observeIframeChanges(containerId);
      });


      // 设置定时器，5分钟后标记为过期
    /*  this.refreshTimer = setTimeout(() => {
        this.status = 'expired';
      }, 5 * 60 * 1000); // 5分钟*/
    },
    observeIframeChanges(containerId){
      // 使用MutationObserver监听DOM变化
      const container = document.getElementById(containerId);
      if (!container) return;
      // 监听容器内元素变化
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // 检查是否有新的iframe被添加
            const iframes = container.querySelectorAll('iframe');
            if (iframes.length > 0) {
              // 重新绑定iframe加载事件
              iframes.forEach(iframe => {
                iframe.onload = () => {
                  console.log('iframe重新加载');
                  // iframe重新加载时重置状态
                  this.resetStatus();
                };
              });
            }
          }
        });
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });

      this.iframeObserver = observer;

      // 同时监听已存在的iframe
      const existingIframe = container.querySelector('iframe');
      if (existingIframe) {
        existingIframe.onload = () => {
          console.log('iframe加载完成');
          this.resetStatus();
        };
      }
    },
    // 重置状态
    /*resetStatus() {
      // 清除之前的定时器
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }

      // 重置状态为扫描中
      this.status = 'scanning';

      // 重新设置定时器
      this.refreshTimer = setTimeout(() => {
        this.status = 'expired';
      }, 5 * 60 * 1000); // 5分钟
    },*/
    handlerBack(){
      this.showChat = false
    }
  },
  beforeDestroy() {
    // 清理二维码容器的ID
    if (this.$refs.qrCode) {
      this.$refs.qrCode.id = '';
    }

    // 清理observer
    if (this.iframeObserver) {
      this.iframeObserver.disconnect();
    }

    // 清理二维码容器的ID
    if (this.$refs.qrCode) {
      this.$refs.qrCode.id = '';
    }
  }
}
